module.exports = __webpack_public_path__ + "media/svg/digitalintegre-ec5e6177.svg";